import { render, staticRenderFns } from "./fullactivities.vue?vue&type=template&id=21b21259&scoped=true&"
import script from "./fullactivities.vue?vue&type=script&lang=js&"
export * from "./fullactivities.vue?vue&type=script&lang=js&"
import style0 from "./fullactivities.vue?vue&type=style&index=0&id=21b21259&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b21259",
  null
  
)

export default component.exports